module.exports = __webpack_public_path__ + "media/src/ui/images/iconPc_Mobile-84770ecae57be893a26e5e85b6827409.svg";